<template>
  <pt-adult-sell-order-handle-table class="pt-adult-sell-order-handle-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels" :status="status">
     <slot/>
  </pt-adult-sell-order-handle-table>
</template>

<script>
import ptAdultSellOrderHandleTable from './index'
export default {
  name: 'pt-adult-sell-order-handle-table__withData',
  components: {
    'pt-adult-sell-order-handle-table': ptAdultSellOrderHandleTable
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: [],
      currentParams: {}
    }
  },
  props: {
    status: {
      type: String,
      required: true
    },
    tableLabels: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    status (val, old) {
      this.$refs.table.reload()
    }
  },
  methods: {
    buildFilterParams (page, params = {}) {
      if (Object.keys(params).length) {
        params.pageable['page'] = page
        params.pageable['size'] = this.pageSize
        return params
      } else {
        return {
          status: this.status.split(','),
          pageable: { page: page, size: this.pageSize, sort: ['createdDate,asc'] }
        }
      }
    },
    getDataList (page, next) {
      // let data = {
      //   status: this.status.split(','),
      //   pageable: { page: page, size: this.pageSize, sort: ['createdDate,asc'] }
      // }
      let data = this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('AdultorderHandleList', data).then(res => {
        next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
